import RoomPrice from './RoomPrice';

export default RoomPrice;